import Menu, { IMenu } from 'components/Menu';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserInfoRedux } from 'reducers/shareData/selector';
import Header from 'components/Header';
import background from '../img/BG_2_02.jpg';
import { getFindDropDown } from '../main_api';

/** 退關_退運作業查詢 */
const EmptyPage = (): JSX.Element => {
  const { user } = useSelector(getUserInfoRedux);

  // 讀取特定 localStorage 的值並清空該 localStorage
  function getAndClearlocalStorage(localStorageName: string) {
    const storedData = localStorage.getItem(localStorageName);
    if (!storedData) {
      return null;
    }
    return getFindDropDown('common', 'localStorageValue', {
      localStorageValue: storedData,
    }).then((result: any) => {
      localStorage.removeItem(localStorageName);
      if (result && result.data && result.data.data) {
        return result.data.data as string;
      }
      return null;
    });
  }

  useEffect(() => {
    const runRedirect = async () => {
      const localStorageValue = await getAndClearlocalStorage('qrcode');

      if (localStorageValue) {
        window.opener = null;
        const domain = `${window.location.protocol}//${window.location.hostname}`;
        // 1. 驗證是否為有效的 Base64 格式

        let baseUrl = '';

        switch (domain) {
          // 驗證
          case 'https://vwehu.tradevan.com.tw':
            baseUrl = `https://vwehu.tradevan.com.tw/InvoiceQry`;
            break;
          // 測試
          case 'https://twehu.tradevan.com.tw':
            baseUrl = `https://twehu.tradevan.com.tw/InvoiceQry`;
            break;
          // 測試
          case 'http://127.0.0.1':
            baseUrl = `http://127.0.0.1:3000/InvoiceQry`;
            break;
          // 測試
          case 'http://localhost':
            baseUrl = `http://localhost:3000/InvoiceQry`;
            break;
          // 正式
          case 'https://wehu.tradevan.com.tw':
            baseUrl = `https://wehu.tradevan.com.tw/InvoiceQry`;
            break;
          default:
            break;
        }
        console.log('baseUrl', baseUrl);
        if (baseUrl && localStorageValue) {
          const targetUrl = new URL(baseUrl);
          targetUrl.searchParams.set('value', localStorageValue);

          window.location.href = targetUrl.toString();
        }
      }
    };
    runRedirect();
  }, []);
  return (
    <div
      id="page-area"
      style={{
        backgroundImage: `url(${background})`,
        height: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">退關_退運作業查詢</Typography>
        </Breadcrumbs> */}
      </div>
    </div>
  );
};

export default EmptyPage;
